// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.legend-container {
  align-self: flex-end;
  background: rgba(255, 255, 255, 0.3);
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 4px;
  box-sizing: border-box;
  font-size: 11px;
  margin: 10px 0 0;
  min-width: 0;
  padding: 5px 5px 5px 10px;
  text-align: left;
  width: 100%;
}

.legend-title {
  font-weight: bold;
}

.legend-row {
  display: flex;
  margin-top: 2px;
}

.legend-container .box {
  background-color: gray;
  border: 1px solid black;
  border-radius: 50%;
  content: '';
  height: 9px;
  margin: 2px 5px 0 0;
  width: 9px;
}

.box.maroon {
  background: maroon;
}

.box.red {
  background: red;
}

.box.orange {
  background: orange;
}

.box.green {
  background: green;
}

.box.darkslategray {
  background: darkslategray;
}

.box.blue {
  background: blue;
}

.box.navy {
  background: navy;
}

.box.yellow {
  background: yellow;
}

.box.small {
  height: 3px;
  margin: 5px 8px 0 3px;
  width: 3px;
}
`, "",{"version":3,"sources":["webpack://./src/Components/Legend/Legend.css"],"names":[],"mappings":"AAAA;EACE,oBAAoB;EACpB,oCAAoC;EACpC,oCAAoC;EACpC,kBAAkB;EAClB,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,yBAAyB;EACzB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,UAAU;AACZ","sourcesContent":[".legend-container {\n  align-self: flex-end;\n  background: rgba(255, 255, 255, 0.3);\n  border: 1px solid rgba(0, 0, 0, 0.1);\n  border-radius: 4px;\n  box-sizing: border-box;\n  font-size: 11px;\n  margin: 10px 0 0;\n  min-width: 0;\n  padding: 5px 5px 5px 10px;\n  text-align: left;\n  width: 100%;\n}\n\n.legend-title {\n  font-weight: bold;\n}\n\n.legend-row {\n  display: flex;\n  margin-top: 2px;\n}\n\n.legend-container .box {\n  background-color: gray;\n  border: 1px solid black;\n  border-radius: 50%;\n  content: '';\n  height: 9px;\n  margin: 2px 5px 0 0;\n  width: 9px;\n}\n\n.box.maroon {\n  background: maroon;\n}\n\n.box.red {\n  background: red;\n}\n\n.box.orange {\n  background: orange;\n}\n\n.box.green {\n  background: green;\n}\n\n.box.darkslategray {\n  background: darkslategray;\n}\n\n.box.blue {\n  background: blue;\n}\n\n.box.navy {\n  background: navy;\n}\n\n.box.yellow {\n  background: yellow;\n}\n\n.box.small {\n  height: 3px;\n  margin: 5px 8px 0 3px;\n  width: 3px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
